import io from "socket.io-client";
import { getExchangeRates } from "api/walletApi";
import {
  SOCKET,
  Event,
  sendNotfication,
  DEVELOPMENT,
  Game,
  SITE,
  API,
} from './Helper';
import storage from "./Storage";
import { objectEach } from "highcharts";

/**
 * Socket URL
 */
const ws = SOCKET;

getExchangeRates().then(function (res) {
  Object.keys(res).forEach(function (name, key) {
    let val = res[name];
    Game[name] = parseFloat(val);
  });
}).catch(console.error);
// fetch(api).then(function(req){
//   var res = req.formData;
//   objectEach.keys(res).forEach(function(name,key) {

//     let val = res[name];
//     Game[name] = parseFloat(val);
    
//   });
// }
// );

import Cookies from "js-cookie";
import { showAccountBlockedModal } from "./blockModalHelper";

let isBlockAlertShowing = false;

const handleUserBlocked = (data) => {
  console.warn("[Socket.js] USER BLOCKED EVENT RECEIVED:", data);

  // Clear all storage and cookies immediately so user cannot make authenticated requests
  try {
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("session");
    Cookies.remove("auth");
    Cookies.remove("uid");
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    storage.clear();
  } catch (e) {
    console.error(e);
  }

  // Disconnect socket immediately
  try {
    if (socket && socket.io && socket.io.opts) {
      socket.io.opts.query = { auth_token: null, user_key: null };
    }
    socket.disconnect();
  } catch (e) {}

  // Reset React authentication state
  Event.emit("logout");

  if (!isBlockAlertShowing) {
    isBlockAlertShowing = true;
    showAccountBlockedModal(data, () => {
      isBlockAlertShowing = false;
      window.location.href = '/';
    });
  }

  // If user was inside a game iframe or game page, tear it down immediately
  if (window.location.pathname.includes('/casino') || window.location.pathname.includes('/game')) {
    window.location.href = '/';
  }
};

const attachBlockListeners = (targetSocket) => {
  if (!targetSocket) return;
  targetSocket.off("user_blocked");
  targetSocket.on("user_blocked", handleUserBlocked);
  targetSocket.on("Logout", (msg) => {
    if (msg === "ACCOUNT_BLOCKED") {
      handleUserBlocked({ reason: "Your account has been blocked by administrator." });
    }
  });
};

/**
 * Initialize Socket Connection
 */
let socket;

export const connect = (token) => {
  console.log("[Socket.js] Connecting to:", ws, "with token:", token);
  socket = io.connect(ws, {
    secure: ws.startsWith('wss'),
    transports: ['websocket'],
    withCredentials: false,
    query: {
      auth_token: token,
      user_key: storage.getKey("key"),
    },
  });
  attachBlockListeners(socket);
};

if (!DEVELOPMENT) {
  if (storage.getKey("mthfk") === null) {
    connect(storage.getKey("refreshToken") || storage.getKey("token"));
  }
} else {
  connect(storage.getKey("refreshToken") || storage.getKey("token"));
}

attachBlockListeners(socket);

let dis = false;

socket.on("connect", () => {
  console.log("[Socket.js] Socket connected successfully! ID:", socket.id);
  Event.emit("connect");
  if (DEVELOPMENT) {
    if (dis) {
      console.clear();
    }
  }
});

/*
 * Disconnect Server
 */
socket.on("disconnect", (reason) => {
  console.warn("[Socket.js] Socket disconnected! Reason:", reason);
  Event.emit("disconnect");
  dis = true;
});

/*
 * Disconnect Server for Hacker
 */
Event.on("mthfk", () => {
  if (!DEVELOPMENT) socket.disconnect();
});

export default socket;
